export default __webpack_public_path__ + "static/media/25.38ba8300.png";